/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IDobbiesStoreBasedNotificationsViewProps } from './dobbies-store-based-notifications';

export default (props: IDobbiesStoreBasedNotificationsViewProps) => {
    return (
        <div className='row'>
            {props.notificationModal}
            {props.storeLocationsModal}
        </div>
    );
};
